<template>
  <div id="headerContainer">
    <div id="menuContainer">
      <div id="ciDLcon" @click="onClickCI">
        <img src="../../../assets/b2b/dlcon/ci_dlcon.png" />
      </div>
      <ul id="menus">
        <li
            v-for="(item, index) in this.menuData"
            :key="index"
            :ref="'menu' + index"
            class="menu"
            @click="onClickMenu(item.name, index)"
        >{{item.name}}
          <div style="position: relative;z-index: 100">
            <menu-list-component
                v-if="selectedMenuIndex === index"
                top="40"
                :left="index === 0 ? -110 : -120"
                :menuData="selectedMenuItems"
            />
          </div>
        </li>

      </ul>
      <ul id="rightMenus">
        <router-link tag="li" id="expertButton" to="/">리치고 Expert</router-link>
        <li id="profileButton" @click="onProfile">회원정보</li>
        <li id="loginButton">
          <div v-if="isLoggedin" id="LogoutLabel" @click="onLogout">Logout</div>
          <router-link v-else tag="div" id="loginLabel" to="/dlcon/login">
            Login
          </router-link>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import MenuListComponent from "../../../components/b2b/dlcon/menu/MenuListComponent";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "dlconHeader",
  components: {MenuListComponent},
  computed: {
    ...mapState(["isLoggedin"])
  },
  mounted() {
    // window.addEventListener('mousedown', this.offMenu);
  },
  beforeDestroy() {
    // window.removeEventListener('mousedown', this.offMenu);
  },
  data() {
    return {
      menuData: require('../../../../data/b2b/dlcon_menus.json'),
      selectedMenuIndex: -1,
      selectedMenuItems: []
    }
  },
  methods: {
    ...mapMutations(["logout"]),
    ...mapActions(["updateLoggedin"]),
    onClickCI() {
      this.$router.replace('/dlcon/b2b_market_trend_dashboard_01%2Fb2b_market_trend_dashboard_01_main_01');
    },
    async onLogout() {
      this.logout();
      await this.updateLoggedin();

      if (this.$router.currentRoute.path !== "/dlcon/login") {
        await this.$router.push('/dlcon/login');
      }
      alert('로그아웃 되었습니다.');
    },
    onProfile() {
      if (this.isLoggedin === false) {
        alert('로그인 해주세요.')
        return;
      }
      this.$router.push('/dlcon/profile')

    },
    offMenu() {
      this.selectedMenuIndex = -1;
      this.selectedMenuItems = [];
    },
    onClickMenu(menuName, index) {
      if (this.selectedMenuIndex === index) {
        this.offMenu();
        return;
      }

      for (let i = 0; i < this.menuData.length; ++i) {
        this.$refs[`menu${i}`][0].classList.remove('selectedMenu')
      }

      this.selectedMenuIndex = index;
      this.selectedMenuItems = this.menuData.find(item => item.name === menuName).menuItems;

      // 선택된 메뉴 데이터 셋팅 (할 필요가 있나?)
      this.menuData.forEach(x => x.selected = false);
      this.menuData.find(x => x.name === menuName).selected = true;

      this.$refs[`menu${index}`][0].classList.add('selectedMenu')

    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#headerContainer {
  display: flex;
  justify-content: center;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.6px;
  height: 50px;
  background: #333333;
  color: #FFFFFF;
}

#menuContainer {
  /*background: red;*/
  display: flex;
  /*align-items: center;*/
  justify-content: space-between;
  padding: 0 60px;
  min-width: 1680px;
}

#menus {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}

#menus li {
  text-align: center;
  width: 160px;
}

#menus li {
  margin: 0 18px;
}

.menu:hover {
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 100px;
  color: #333333;
  width: 111px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectedMenu {
  background: #FFFFFF;
  border-radius: 100px;
  color: #333333;
  width: 111px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#ciDLcon {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#ciDLcon:hover {
  cursor: pointer;
}

#ciDLcon > img {
  background-color: #FFFFFF;
  height: 80px;
}

#rightMenus {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  letter-spacing: -0.6px;
  color: #FFFFFF;
}

#rightMenus li {
  padding: 18px 0;
}

#rightMenus li:hover {
  cursor: pointer
}

#expertButton {
  width: 100px;
}

#profileButton {
  width: 100px;
}

#loginButton {
  width: 100px;
  margin-left: 8px;
}

#loginLabel, #LogoutLabel {
  background: #565656;
  border-radius: 100px;
  padding: 4px 8px;
  width: 61px;
  height: 20px;
}

</style>
